import { render } from "./EditServicePage.vue?vue&type=template&id=307fcf18&ts=true"
import script from "./EditServicePage.vue?vue&type=script&lang=ts"
export * from "./EditServicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__